import React from 'react';
import { Section } from './ui/Section';
export function ValueFraming() {
  const steps = ['APRENDER', 'ENTENDER', 'ADAPTAR', 'RECREAR'];
  return <Section variant="alt" data-id="element-178" data-mp="2kj70j3ifbq5p">
      <div className="max-w-2xl mx-auto text-center" data-id="element-179" data-mp="2pi1ffud9sukj">
        <p className="font-display text-xl md:text-2xl text-brand-title italic mb-2 leading-snug" data-id="element-180" data-mp="2ph8e58x2yx9s">
          No estás comprando una colección de recetas.
        </p>
        <p className="font-body text-brand-text leading-relaxed mb-10" data-id="element-181" data-mp="2yj80mgqv6tk4">
          Estás accediendo a un sistema pensado para enseñarte a sustituir,
          adaptar y recrear por tu cuenta.
        </p>

        <div className="flex items-center justify-center gap-1.5 md:gap-3 flex-wrap" data-id="element-182" data-mp="3889dvz60ywue">
          {steps.map((step, i) => <React.Fragment key={i} data-id="element-183" data-mp="3d6kmy7ohx3bk" data-mpi={i}>
              <span className="font-heading font-bold text-brand-primary text-xs md:text-base uppercase tracking-[0.1em] bg-white border border-brand-border rounded-full px-3 md:px-5 py-2" data-id="element-184" data-mp="3d9ozbsc475db">
                {step}
              </span>
              {i < steps.length - 1 && <span className="text-brand-secondary text-lg" data-id="element-185" data-mp="1vxq3676i6dgf">→</span>}
            </React.Fragment>)}
        </div>
      </div>
    </Section>;
}